<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            الخدمات قبل وبعد النزاع 2015
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            مقارنة حجم المستفيدين قبل النزاع مقابل الوضع الراهن
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-services')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card primary">
          <div class="kpi-value">847,400</div>
          <div class="kpi-label">السكان المخدومون حالياً</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">-32%</div>
          <div class="kpi-label">انخفاض عن ما قبل النزاع</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">4</div>
          <div class="kpi-label">خدمات توقفت كلياً</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">220,000</div>
          <div class="kpi-label">نازح مضاف</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">حجم الخدمات قبل النزاع مقابل الراهن</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>المستفيدون/شهر قبل 2015</th>
            <th>المستفيدون الحاليون</th>
            <th>نسبة التغيير</th>
            <th>السبب الرئيسي</th>
            <th>الخدمات المتوقفة</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>{{ item.before }}</td>
            <td>{{ item.current }}</td>
            <td class="font-weight-bold" :class="changeClass(item.change)">
              {{ item.change }}
            </td>
            <td>{{ item.reason }}</td>
            <td>{{ item.stoppedServices }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    before: "8,500",
    current: "5,200",
    change: "-38%",
    reason: "ضرر هيكلي + نقص كادر",
    stoppedServices: "جراحة مخططة، ICU",
  },
  {
    name: "مستشفى الأمراض النفسية",
    before: "2,800",
    current: "1,400",
    change: "-50%",
    reason: "ضرر هيكلي",
    stoppedServices: "خدمات نفسية متخصصة",
  },
  {
    name: "مجمع الشيخ عثمان",
    before: "4,200",
    current: "2,800",
    change: "-33%",
    reason: "نقص التمويل",
    stoppedServices: "رقود مرضى",
  },
  {
    name: "مركز كود العثماني",
    before: "1,800",
    current: "1,600",
    change: "-11%",
    reason: "نقص كادر جزئي",
    stoppedServices: "—",
  },
  {
    name: "مركز الممدارة",
    before: "2,200",
    current: "2,100",
    change: "-5%",
    reason: "لا يوجد",
    stoppedServices: "—",
  },
  {
    name: "مركز المحاريق",
    before: "1,600",
    current: "1,100",
    change: "-31%",
    reason: "انقطاع تمويل",
    stoppedServices: "—",
  },
  {
    name: "مركز عبد القوي",
    before: "1,900",
    current: "1,750",
    change: "-8%",
    reason: "لا يوجد",
    stoppedServices: "—",
  },
  {
    name: "مركز ماري ستبوس",
    before: "950",
    current: "0",
    change: "-100%",
    reason: "ضرر شديد + لا كهرباء",
    stoppedServices: "جميع خدمات SRH",
  },
  {
    name: "جمعية حقوق الطفل",
    before: "600",
    current: "580",
    change: "-3%",
    reason: "لا يوجد",
    stoppedServices: "—",
  },
];

const changeClass = (value) => {
  const number = Math.abs(Number(value.replace("%", "")));
  if (number >= 30) return "text-red-darken-2";
  return "text-orange-darken-2";
};

const showView = (view) => {
  console.log("Go to:", view);
};
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.primary {
  background: #f0f1f2;
  color: #4a4f55;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
